module.exports = __webpack_public_path__ + "img/additonal-company.svg";